import { throwError as observableThrowError } from "rxjs";
import { Jsonp } from "@angular/http";
import { catchError, map } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "@angular/http";
var URSService = /** @class */ (function () {
    function URSService(jsonp) {
        this.jsonp = jsonp;
    }
    URSService.prototype.evaluateURSRestriction = function (ursURL) {
        return this.jsonp
            .request(ursURL + "?format=jsonp&callback=JSONP_CALLBACK")
            .pipe(map(function (res) {
            var ursObj = res.json();
            if (ursObj.status === "ok") {
                return { url: ursObj.url };
            }
            else {
                return { error: ursObj.http_code };
            }
        }), catchError(function (error) { return observableThrowError(error); }));
    };
    URSService.ngInjectableDef = i0.defineInjectable({ factory: function URSService_Factory() { return new URSService(i0.inject(i1.Jsonp)); }, token: URSService, providedIn: "root" });
    return URSService;
}());
export { URSService };
